import * as styles from "./styles.css";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../../components/atoms/icon";
import { cn } from "@discovery/classnames";
import { useState } from "@discovery/common-dplus/lib/hooks";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
const Description = ({ videoName, genre, descriptionM, }) => {
    const [showDescription, setShowDescription] = useState(false);
    const openChevron = () => {
        setShowDescription(!showDescription);
    };
    const description = M.fromMaybe(descriptionM, "");
    const Details = () => {
        return (React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { classNameM: M.of(cn(styles.description, {
                [styles.show]: showDescription,
            })), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, description))), descriptionM)));
    };
    const ChevronIcon = () => {
        return (React.createElement("div", { onClick: openChevron, className: styles.chevronWrap },
            React.createElement(Icon, { className: styles.iconStyles, color: "white", type: showDescription ? Icons.ChevronUp : Icons.ChevronDown })));
    };
    const renderGeners = () => {
        return (genre &&
            genre.map((item, index) => {
                return (React.createElement("div", { key: index, className: styles.flexWrapper },
                    index !== 0 && React.createElement("div", { className: styles.dot }),
                    React.createElement(Typography, { classNameM: M.of(cn(styles.descriptionTypes, styles.genre)), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, item))));
            }));
    };
    const RenderDesc = () => {
        return (React.createElement("div", { className: styles.detailWrapperMobile },
            React.createElement("div", { className: styles.title }, videoName),
            React.createElement("div", { className: styles.flexWrapper },
                renderGeners(),
                description && React.createElement(ChevronIcon, null)),
            React.createElement("div", { className: styles.desc },
                React.createElement(Details, null))));
    };
    return React.createElement(RenderDesc, null);
};
export default Description;

